import React, { Component } from 'react';
import Collapsible from 'react-collapsible';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { connect } from 'react-redux';
import api from '../../axios-local-api';
import Spinner from '../../components/UI/Spinner/Spinner';
import Box from '../../hoc/Box/Box';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import * as actions from '../../store/actions/index';
import classes from './EquipmentStatus.css';
import { EquipmentTypes } from '../../shared/common';
import ErrorAlert from '../../shared/Alert/ErrorAlert';
import { initCellular } from '../../store/actions/cellularBackup';

class EquipmentStatus extends Component {
  constructor(props) {
    super(props);
    const isMobile = window.innerWidth <= 900;
    this.state = {
      upArrow: isMobile && props.podNames !== undefined,
    };
  }

  componentDidMount() {
    this.props.onInitCellular();
  }

  
  componentDidUpdate(prevProps) {
    if (window.innerWidth <= 900 && prevProps.podNames !== this.props.podNames && this.props.podNames !== undefined) {
      this.setState({
        upArrow: true,
      });
    }
  }
  openHandler() {
    this.setState({
      upArrow: true,
    });
  }
  closeHandler() {
    this.setState({
      upArrow: false,
    });
  }

  getFreqBand = (freqBand) => {
    if (freqBand && (freqBand.includes('5G') || freqBand.includes('5g'))) {
      return '5GHz';
    } else if (
      freqBand &&
      (freqBand.includes('2.4G') || freqBand.includes('2.4g'))
    ) {
      return '2.4GHz';
    } else if (
      freqBand &&
      (freqBand.includes('6G') || freqBand.includes('6g'))
    ) {
      return '6GHz';
    }
    return '';
  };
  getTableRowContent = (data, type, parentPod, deviceType) => {
    // console.log("data, type, parentPod,deviceType:", data, type, parentPod,deviceType);
    const colorCode = {
      connected: 'green',
      excellent: 'green',
      disconnected: 'red',
      poor: 'red',
      good: 'green',
      fair: 'red',
      calculating: 'orange',
    };
    let connectedTo = 'N/A';

    let connectedDevice = 'N/A';
    let deviceName;
    let model;
    let signalStatus = data.health ? data.health.status : 'disconnected';
    if (type === EquipmentTypes.Router) {
      const isCellularActive = this.props.cellularData?.lteState?.connectionState?.active;
      connectedTo = data.health ? 'Modem' : connectedTo;
      if (signalStatus === 'disconnected') {
        deviceName = 'Router';
      } else {
        deviceName = data.health ? 'Router' : data.defaultName;
      }

      if (isCellularActive) {
        deviceName = 'Invincible WiFi Router';
        connectedDevice = 'Cellular';
        connectedTo = 'N/A';
        signalStatus = 'Connected';
      } else if (data.connectionState === 'disconnected') {
        connectedDevice = 'N/A';
      } else {
        connectedDevice = 'Ethernet';
      }
      model = this.props?.wan?.realWan?.model;
      if (!isCellularActive) {
        signalStatus =
          data.backhaulType === 'ethernet' || connectedTo === 'Modem'
            ? 'Connected'
            : signalStatus;
      }
      if (this.props.wan && this.props.wan.checkingWan) {
        signalStatus = 'disconnected';
      }
    } else if (type === EquipmentTypes.Pod) {
      //console.log(data.health);
      if (data.connectionState === 'disconnected') {
        connectedDevice = 'N/A';
      } else {
        connectedDevice = !data.health
          ? 'N/A'
          : data.health && data.health.status === 'disconnected'
            ? 'N/A'
            : data.backhaulType === 'ethernet'
              ? 'Ethernet'
              : data.backHaul && data.backHaul.metadata
                ? `${this.getFreqBand(data.backHaul.metadata.freqBand)}/${data.backHaul.metadata.channel
                }`
                : connectedDevice;
      }
      connectedTo = !data.health
        ? 'N/A'
        : data.health && data.health.status === 'disconnected'
          ? 'N/A'
          : data.backhaulType === 'ethernet'
            ? 'Ethernet'
            : parentPod
              ? parentPod.nickname || parentPod.defaultName
              : connectedTo;
      deviceName = data.nickname ? data.nickname : data.defaultName;
      model = data.model;
      signalStatus =
        data.backhaulType === 'ethernet' ? 'Connected' : signalStatus;
      if (
        this.props.wan &&
        (this.props.wan.checkingWan ||
          (this.props.wan.podTimer && this.props.wan.rebootPodId === data.id))
      ) {
        signalStatus = 'disconnected';
      }
    } else if (type === 'unclaimedpod') {
      // console.log(data.health);
      connectedDevice = 'N/A';
      connectedTo = 'N/A';
      deviceName = data.serialNumber;
      model = data.vendorModel;
      signalStatus = 'unclaimed';
    }
    let colorStyleCode = '#6F777E';
    let colorClassname;

    if (signalStatus === 'disconnected') {
      colorStyleCode = colorCode.disconnected;
      colorClassname = classes.disconnected;
    } else {
      colorStyleCode = data.health
        ? colorCode[data.health.status]
        : colorCode.disconnected;
      colorClassname = data.health
        ? classes[data.health.status]
        : classes.disconnected;
    }

    const colorDot = (
      <div
        className={classes.colorDot}
        style={{ display: 'flex', alignItems: 'center' }}
      >
        <div className={colorClassname}></div>
        <div style={{ width: '10px' }} />
        <div
          id="signal"
          className={classes.statusName}
          style={{ color: colorStyleCode }}
        >
          {signalStatus}
        </div>
      </div>
    );



    if (deviceType === 'Mobile') {
      return (
        <Box>
          <tr>
            <td
              style={{
                padding: '16px',
                borderRight: 'none',
                borderLeft: 'none',
                overflowWrap: 'break-word',
                width: '185px',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-all',
                '-webkit-line-clamp': '3',
                '-webkit-box-orient': 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box'
              }}>
              {deviceName}
            </td>
          </tr>
        </Box>
      );
    } else {
      let connectedDeviceWithColor;
      if (signalStatus === 'disconnected') {
        connectedTo = 'N/A';
        connectedDeviceWithColor = (
          <td
            id="EquipmentConnection"
            className={classes.connection_column}
            style={{ padding: '10px', borderRight: 'none', borderLeft: 'none' }}
          >
            N/A
          </td>
        );
      } else {
        if (connectedDevice.includes('2.4GHz')) {
          connectedDeviceWithColor = (
            <td
              id="EquipmentConnection"
              className={classes.connection_column}
              style={{
                padding: '10px',
                borderRight: 'none',
                borderLeft: 'none',
                // color: 'red',
              }}
            >
              {connectedDevice}
            </td>
          );
        } else {
          if (connectedDevice === 'ethernet') {
            connectedDevice = 'Ethernet';
          }
          connectedDeviceWithColor = (
            <td
              id="EquipmentConnection"
              className={classes.connection_column}
              style={{
                padding: '10px',
                borderRight: 'none',
                borderLeft: 'none',
              }}
            >
              {connectedDevice}
            </td>
          );
        }
      }

      return (
        <tr className={classes.trTag}>
          <td
            id="EquipmentName"
            style={{
              padding: '16px',
              borderRight: 'none',
              borderLeft: 'none',
            }}
            className={[classes.showDesktop, classes.showDesktop1].join(' ')}
          >
            <div style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={deviceName}>
              {deviceName}
            </div>
          </td>

          <td
            id="Equipmentsignal"
            style={{ padding: '16px', borderRight: 'none', borderLeft: 'none' }}
          >
            {colorDot}
          </td>
          {connectedDeviceWithColor}

          <td
            id="EquipmentConnectedTo"
            style={{
              padding: '10px',
              borderRight: 'none',
              borderLeft: 'none',
              overflowWrap: 'break-word',
            }}
          >
            {connectedTo}
          </td>
          <td
            id="EquipmentModel"
            style={{ padding: '10px', borderRight: 'none', borderLeft: 'none' }}
          >
            {model}
          </td>
        </tr>
      );
    }
  };

  getEquipmentStatusRows = (deviceType = '') => {
    const realWan = this.props.realWan;
    const claimedPods = this.props.claimedPods;
    const unclaimedPods = this.props.unclaimedPods;
    // console.log(this.props, 'unclaimed pods')
    const equipmentStatusContent = [];
    if (!realWan) {
      return undefined;
    }
    if (realWan && typeof realWan === 'object' && Object.keys(realWan).length) {
      equipmentStatusContent.push(
        this.getTableRowContent(realWan, 'router', '', deviceType)
      );
    }

    if (claimedPods && claimedPods.length) {
      let router = {
        id: realWan.id,
        mac: realWan.mac,
        //Wanted to display name as Router in the connectedTo column if the parent is Router
        nickname: 'Router',
      };
      let claimedPodMap = claimedPods.reduce((acc, cpod) => {
        acc[cpod.id] = cpod;
        return acc;
      }, {});
      claimedPodMap[router.id] = router;

      claimedPods.forEach((pod) => {
        let parentId =
          pod.leafToRoot && pod.leafToRoot.length
            ? pod.leafToRoot[0].id
            : undefined;
        let parentPod;
        if (parentId) {
          parentPod = claimedPodMap[parentId];
        } else {
          parentPod = router;
        }
        equipmentStatusContent.push(
          this.getTableRowContent(pod, EquipmentTypes.Pod, parentPod, deviceType)
        );
      });
    }

    if (unclaimedPods && unclaimedPods.length) {
      let router = {
        id: realWan.id,
        mac: realWan.mac,
        //Wanted to display name as Router in the connectedTo column if the parent is Router
        nickname: 'Router',
      };
      let unClaimedPodMap = unclaimedPods.reduce((acc, cpod) => {
        acc[cpod.id] = cpod;
        return acc;
      }, {});
      unClaimedPodMap[router.id] = router;
      unclaimedPods.forEach((pod) => {
        // console.log("EquipmentStatus generating row for pod", pod);
        let parentId =
          pod.leafToRoot && pod.leafToRoot.length
            ? pod.leafToRoot[0].id
            : undefined;
        // console.log("EquipmentStatus parentId", parentId);
        let parentPod;
        if (parentId) {
          parentPod = unClaimedPodMap[parentId];
        } else {
          parentPod = router;
        }
        equipmentStatusContent.push(
          this.getTableRowContent(pod, 'unclaimedpod', parentPod, deviceType)
        );
      });
    }

    return equipmentStatusContent;
  };
  render() {
    let arrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    if (this.state.upArrow) {
      arrow = <MdKeyboardArrowUp color={'gray'} size={'30px'} />;
    } else {
      arrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    }

    let infoRow;
    let equipNameData;
    if(this.props.wan.error) {
      infoRow = <ErrorAlert />
    } else if (this.props.loading || !this.props.loaded) {
      infoRow = <Spinner />;
    } else {
      infoRow = (
        <div>
          <div className={classes.showMobile} style={{ float: 'left' }}>
            <table className={classes.devTable} cellPadding="0" cellSpacing="0">
              <thead>
                <tr>
                  <th
                    style={{
                      borderLeft: 'none',
                      borderRight: 'none',
                      textAlign: 'left',
                      padding: '16px',
                      color: 'grey',
                      width: '155px',
                    }}
                  >
                    Equip. Name
                  </th>
                </tr>
              </thead>
              <tbody>{this.getEquipmentStatusRows('Mobile')}</tbody>
            </table>
          </div>

          <div className={classes.tablewrapper}>
            <table className={classes.devTable} cellPadding="0" cellSpacing="0">
              <thead>
                <tr className={classes.trTag}>
                  <th
                    className={classes.showDesktop}
                    style={{
                      borderLeft: 'none',
                      borderRight: 'none',
                      textAlign: 'left',
                      padding: '16px',
                      color: 'grey',
                    }}
                  >
                    Equip. Name
                  </th>

                  <th
                    style={{
                      borderLeft: 'none',
                      borderRight: 'none',
                      textAlign: 'left',
                      padding: '16px',
                      color: 'grey',
                    }}
                  >
                    Signal
                  </th>

                  <th
                    style={{
                      borderLeft: 'none',
                      borderRight: 'none',
                      textAlign: 'left',
                      padding: '16px',
                      color: 'grey',
                    }}
                  >
                    Connection
                  </th>

                  <th
                    style={{
                      borderLeft: 'none',
                      borderRight: 'none',
                      textAlign: 'left',
                      padding: '10px',
                      color: 'grey',
                    }}
                  >
                    Connected To
                  </th>

                  <th
                    style={{
                      borderLeft: 'none',
                      borderRight: 'none',
                      textAlign: 'left',
                      padding: '10px',
                      color: 'grey',
                    }}
                  >
                    Model #
                  </th>
                </tr>
              </thead>
              <tbody>{this.getEquipmentStatusRows('Desktop')}</tbody>
            </table>
          </div>
        </div>
      );
    }
    return (
      <Box>
        <div className={classes.showDesktop}>
          <div className={classes.EquipmentStatusComponent}>
            <div className={classes.EquipmentStatusComponentCollapse}>
              <div className={classes.TitleArea}>
                <h3 style={{ paddingRight: 20 }}>Equipment Status</h3>

              </div>
              <div className={classes.HorizontalSeparator} />
            </div>
            {infoRow}
          </div>
        </div>

        <div className={classes.showMobile}>
          <div className={classes.EquipmentStatusComponent}>
            <Collapsible
              transitionTime={100}
              onOpening={() => {
                this.openHandler();
              }}
              onClosing={() => {
                this.closeHandler();
              }}
              trigger={
                <Box>
                  <div className={classes.EquipmentStatusComponentCollapse}>
                    <div className={classes.TitleArea}>
                      <h3 style={{ paddingRight: 20 }}>Equipment Status</h3>
                      <button
                        className={classes.OpenCloseButton}
                        style={{ float: 'right' }}
                        aria-label="open arrow"
                      >
                        {arrow}
                      </button>
                    </div>

                    <div className={classes.HorizontalSeparator} />
                  </div>
                </Box>
              }
              open={this.state.upArrow}
            >
              {infoRow}
            </Collapsible>
          </div>
        </div>
      </Box>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    loading: state.equipment.loading,
    loaded: state.equipment.loaded,
    realWan: state.wan.realWan,
    equipment: state.equipment,
    claimedPods:
      state.equipment && state.equipment.realEquipment
        ? state.equipment.realEquipment.claimedPods
        : [],
    unclaimedPods: sessionStorage.getItem("multi") === true || sessionStorage.getItem("multi") === "true"
      ? state.multiRouter?.multiRouter?.unclaimedPods
      :state.equipment && state.equipment.realEquipment
        ? state.equipment.realEquipment.unclaimedPods
        : [],
    wan: state.wan,
    cellularData: state.cellularBackup.cellularData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onInitWan: () => dispatch(actions.initWan()),
    onInitEquipment: () => {
      dispatch(actions.initEquipment());
    },
    refreshDevices: () => dispatch(actions.refreshDevices()),
    onInitCellular: () => dispatch(initCellular()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(EquipmentStatus, api));
